const riot = require('riot');

riot.tag2('page-password-reset', '<div class="f fh s-full"> <div class="f fh fclm bg-white py32 px70 text-label_high rounded-8"> <div class="lh15 letter-spacing-0_03em bold mb24" if="{mode === &quot;sending&quot;}">パスワード再設定</div> <div class="f fh fclm w-full" if="{mode === &quot;sending&quot;}"> <div class="lh15 text-center mb24">登録されたメールアドレス宛に<br>パスワード再設定のURLを送信します。</div> <form class="f fclm mb16" onsubmit="{onSubmit}"> <input class="border h40 w280 px8 rounded-4 mb16" ref="email" placeholder="メールアドレス" required type="email"> <button class="button primary_fill h40 w-full">送信</button> </form><a class="lh15 fs11 text-primary" href="/signin">ログイン</a> </div> <div class="w280" if="{mode === &quot;completed&quot;}" onsubmit="{onSubmit}"> <div class="fs18 lh15 letter-spacing-0_03em bold text-center mb12">送信完了</div> <div class="lh15 text-center mb24"><span class="bold">{email}</span><span>に<br>パスワード再設定のURLを送信しました。<br>メールが届かない場合や紛失した場合は、以下より再送信してください。</span></div> <button class="button primary_fill h40 w-full transition">再送信</button> </div> </div> </div>', 'page-password-reset,[data-is="page-password-reset"]{display:block}', '', function(opts) {
    this.on('show', () => {
      this.mode = 'sending';
    });

    this.onSubmit = async (e) => {
      e.preventDefault();
      if (this.mode === 'sending') {
        this.email = this.refs.email.value;
      }

      if (this.mode === 'completed') {
        spat.toast.message(`${this.email}へ再送信しました`);
      }

      this.update({
        mode: 'completed',
        email: this.email,
      });
    };
});